function getProcessEnvValue(key: string): string | undefined {
  const processRef = (globalThis as Record<string, unknown>).process as
    | { env?: Record<string, string | undefined> }
    | undefined;

  if (!processRef?.env) {
    return undefined;
  }

  return processRef.env[key];
}

function getEnvValue(globalKey: string, processKey: string, fallback: string = ''): string {
  const globalValue = (globalThis as Record<string, unknown>)[globalKey];
  if (globalValue !== undefined && globalValue !== null) {
    return String(globalValue);
  }

  const processValue = getProcessEnvValue(processKey);
  if (processValue !== undefined && processValue !== null) {
    return String(processValue);
  }

  return fallback;
}

function toBool(value: string): boolean {
  return ['true', '1', 'yes'].includes(value.toLowerCase());
}

function isLocalhostHost(): boolean {
  if (typeof window === 'undefined' || !window.location) {
    return false;
  }

  const hostname = window.location.hostname;
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

const localModeFlag = toBool(getEnvValue('__VITE_LOCAL_MODE__', 'VITE_LOCAL_MODE', ''));
const localhostHost = isLocalhostHost();

export const env = {
  // Local mode is intentionally restricted to localhost only.
  localMode: localhostHost && localModeFlag,
  useDummyAuth: toBool(getEnvValue('__VITE_USE_DUMMY_AUTH__', 'VITE_USE_DUMMY_AUTH', '')),
  localUnid: getEnvValue('__VITE_LOCAL_UNID__', 'VITE_LOCAL_UNID', 'u1234567'),
  arcgisApiKey: getEnvValue('__VITE_ARCGIS_API_KEY__', 'VITE_ARCGIS_API_KEY', ''),
};
